import {BRANDS} from 'const'

import beobachter from './brands/beobachter/components'
import blick from './brands/blick/components'
import energy from './brands/energy/components'
import illustre from './brands/illustre/components'
import interview from './brands/interview/components'
import lematin from './brands/lematin/components'
import moonandstars from './brands/moonandstars/components'
import pme from './brands/pme/components'
import onelog from './shared/components/onelog'
import rockit from './brands/rockit/components'
import schlager from './brands/schlager/components'
import schweizerillustrierte from './brands/schweizerillustrierte/components'
import twentymin from './shared/components/twentymin'
import cash from './brands/cash/components'
import txgroup from './shared/components/txgroup'
import vintage from './brands/vintage/components'
import wirtschaftsmedien from './brands/wirtschaftsmedien/components'
import srg from './brands/srg/components'
import jobs from './brands/jobs/components'
import jobup from './brands/jobup/components'
import redsport from './brands/redsport/components'
import caminada from './brands/caminada/components'
import glueckspost from './brands/glueckspost/components'
import programmzeitschriften from './brands/programmzeitschriften/components'
import landliebe from './brands/landliebe/components'
import zff from './brands/zff/components'
import aargauerzeitung from './brands/aargauerzeitung/components'
import jobscout24 from './brands/jobscout24/components'
import ticketcorner from './brands/ticketcorner/components'
import jobbern from './brands/jobbern/components'
import autodesjahres from './brands/autodesjahres/components'
import nzz from './brands/nzz/components'
import watson from './brands/watson/components'

const BRAND_COMPONENTS = {
  [BRANDS.baz]: txgroup,
  [BRANDS.berneroberlander]: txgroup,
  [BRANDS.bernerzeitung]: txgroup,
  [BRANDS.bilan]: txgroup,
  [BRANDS.derbund]: txgroup,
  [BRANDS.derlandbote]: txgroup,
  [BRANDS.finanzundwirtschaft]: txgroup,
  [BRANDS.langenthalertagblatt]: txgroup,
  [BRANDS.lematindimanche]: txgroup,
  [BRANDS.schweizerfamilie]: txgroup,
  [BRANDS.sihltaler]: txgroup,
  [BRANDS.sonntagszeitung]: txgroup,
  [BRANDS.tagesanzeiger]: txgroup,
  [BRANDS.tamedia]: txgroup,
  [BRANDS.thalwileranzeiger]: txgroup,
  [BRANDS.thunertagblatt]: txgroup,
  [BRANDS.tribunedegeneve]: txgroup,
  [BRANDS.twentyfourhours]: txgroup,
  [BRANDS.zurcherunterlander]: txgroup,
  [BRANDS.zurichseezeitung]: txgroup,

  [BRANDS.beobachter]: beobachter,
  [BRANDS.blick]: blick,
  [BRANDS.energy]: energy,
  [BRANDS.illustre]: illustre,
  [BRANDS.lematin]: lematin,
  [BRANDS.moonandstars]: moonandstars,
  [BRANDS.onelog]: onelog,
  [BRANDS.pme]: pme,
  [BRANDS.srg]: srg,
  [BRANDS.rockit]: rockit,
  [BRANDS.schlager]: schlager,
  [BRANDS.schweizerillustrierte]: schweizerillustrierte,
  [BRANDS.testing]: blick,
  [BRANDS.twentymin]: twentymin,
  [BRANDS.lessentiel]: twentymin,
  [BRANDS.vintage]: vintage,
  [BRANDS.wirtschaftsmedien]: wirtschaftsmedien,
  [BRANDS.cash]: cash,
  [BRANDS.interview]: interview,
  [BRANDS.jobs]: jobs,
  [BRANDS.jobup]: jobup,
  [BRANDS.jobscout24]: jobscout24,
  [BRANDS.redsport]: redsport,
  [BRANDS.caminada]: caminada,
  [BRANDS.glueckspost]: glueckspost,
  [BRANDS.programmzeitschriften]: programmzeitschriften,
  [BRANDS.landliebe]: landliebe,
  [BRANDS.zff]: zff,
  [BRANDS.aargauerzeitung]: aargauerzeitung,
  [BRANDS.ticketcorner]: ticketcorner,
  [BRANDS.jobbern]: jobbern,
  [BRANDS.autodesjahres]: autodesjahres,
  [BRANDS.nzz]: nzz,
  [BRANDS.watson]: watson,
}

const getBrandComponents = brand => BRAND_COMPONENTS[brand]

export {getBrandComponents}
